import { connect } from 'react-redux';
import { setIsNavDrawerOpen } from './navigationSlice';
import Navigation from './Navigation';

const mapState = state => ({
  isNavHidden: state.navigation.isNavHidden,
});

const mapDispatch = {
  setIsNavDrawerOpen,
};

export default connect(mapState, mapDispatch)(Navigation);
